import { DateTime } from 'luxon'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['allSettings', 'shopId', 'locale', 'timezone', 'dateFormat']),
    subscriptionCurrency () {
      const settings = this.allSettings ? this.allSettings[this.shopId + '-' + this.locale] : null
      return settings && settings.currency ? settings.currency : 'EUR'
    }
  },
  methods: {
    statusName (subscription) {
      switch (subscription.status) {
        case 'active':
          return subscription.cancelled ? this._('Cancelled') : this._('Active')
        case 'suspended':
          return this._('Suspended')
        case 'ended':
          return this._('Ended')
        default:
          return subscription.status
      }
    },
    statusClass (subscription) {
      switch (subscription.status) {
        case 'active':
          return subscription.cancelled ? 'warning' : 'success'
        case 'suspended':
          return 'danger'
        default:
          return 'default'
      }
    },
    intervalName (interval, count) {
      const n = parseInt(count, 10) || 1
      switch (interval) {
        case 'day':
          return n === 1 ? this._('Daily') : this._('Every %s days').replace('%s', n)
        case 'week':
          return n === 1 ? this._('Weekly') : this._('Every %s weeks').replace('%s', n)
        case 'month':
          return n === 1 ? this._('Monthly') : this._('Every %s months').replace('%s', n)
        case 'year':
          return n === 1 ? this._('Yearly') : this._('Every %s years').replace('%s', n)
        default:
          return interval
      }
    },
    paymentMethodName (payment) {
      return payment === 'bill' ? this._('Invoice') : this._('Payment link')
    },
    formatDate (ts) {
      if (!ts || !parseInt(ts, 10)) {
        return ''
      }
      return DateTime.fromSeconds(Number(ts), { zone: this.timezone }).toFormat(this.dateFormat || 'd.M.yyyy')
    },
    // Period ends are exclusive timestamps; show the last day that is still included
    formatLastDay (ts) {
      if (!ts || !parseInt(ts, 10)) {
        return ''
      }
      return DateTime.fromSeconds(Number(ts), { zone: this.timezone }).minus({ days: 1 }).toFormat(this.dateFormat || 'd.M.yyyy')
    },
    formatDateTime (ts) {
      if (!ts || !parseInt(ts, 10)) {
        return ''
      }
      return DateTime.fromSeconds(Number(ts), { zone: this.timezone }).toFormat((this.dateFormat || 'd.M.yyyy') + ' HH:mm')
    },
    formatPrice (amount) {
      return this.$filters.currency(amount, this.subscriptionCurrency)
    }
  }
}
